import { render, staticRenderFns } from "./LiveIncome.vue?vue&type=template&id=a1825786&scoped=true&"
import script from "./LiveIncome.vue?vue&type=script&lang=js&"
export * from "./LiveIncome.vue?vue&type=script&lang=js&"
import style0 from "./LiveIncome.vue?vue&type=style&index=0&id=a1825786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1825786",
  null
  
)

export default component.exports